module.exports = __webpack_public_path__ + "static/media/18.29dc5bab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/18.svg
// module id = 390
// module chunks = 14